import axios from "axios";

export async function getSellersControlService(uid: string, dayInit: string, dayEnd: string) {
    let serviceResponse: any = null;
    

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_SERVICE_URL}/documents/get/v2/compliance/range`,
            {
                "data": {
                    dayInit,
                    dayEnd
                }
            },
            {
                headers: {
                    'Authorization': `UserToken ${uid}`
                },
                timeout: 15000,
            }
        );

        if (res.data.data && res.data.data.length > 0) {
            serviceResponse = res.data.data;
        }
        console.log("Servicio Datos de vendedor:", serviceResponse);
        // console.log("Parametros enviados:", { dayInit, dayEnd, uid });
        // console.log("URL Servicio:", `${process.env.REACT_APP_SERVICE_URL}/documents/get/v2/compliance/range`);
        
        

    } catch (error) {
        return null;
    }

    return serviceResponse;
}

export async function getRoutesSellerService(uid: string, dayInit: string, dayEnd: string) {
    let serviceResponse: any = null;
    


    const headers = {
        'Authorization': `UserToken ${uid}`,
    }

    try {
        const res = await axios.get(
            `${process.env.REACT_APP_SERVICE_URL}/sapuser/get/vendor/router`,
            {
                headers,
                params: {
                    dateStart: dayInit,
                    dateEnd: dayEnd,
                }
            },

        );

        if (res.data.data && res.data.data.length > 0) {
            serviceResponse = res.data.data;
        }
        console.log("Servicio Listado de Rutas:", serviceResponse);

    } catch (error) {
        return null;
    }

    return serviceResponse;
}